import { CHANNEL_TYPES } from '@libs/constants';
import h from '../../../../helpers/common';
import useChannelListByCategory from '../../../../hooks/useChannelListByCategory';
import { __ } from '../../../../translations';
import { ChannelsCarousel } from '../../../ui/ChannelsCarousel';
import Loader from './Loader';
import NoContentBanner from './NoContentBanner';

const LiveTVChannels = ({ category, onChangeMood, onItemClick = undefined }) => {
    const { channels, loading } = useChannelListByCategory(category);

    if (!loading && (!channels || channels.length === 0)) {
        return <NoContentBanner onChangeMood={onChangeMood} />;
    }

    const title = __(category.title_resource_key || 'moods_live_tv_asset_title');

    return (
        <>
            {loading ? (
                <Loader length={7} onChangeMood={onChangeMood} title={title} />
            ) : (
                <ChannelsCarousel
                    id="channel-results"
                    data_stream={CHANNEL_TYPES.EMBED_CHANNELS}
                    content={channels}
                    meta={{
                        title: {
                            [h.getLang()]: title,
                        },
                    }}
                    params={{ items_count: channels.length }}
                    onSeeAllClick={onChangeMood}
                    seeAllText={__('moods_change_mood_text')}
                    seeAllUrl="#"
                    onChannelClick={onItemClick}
                />
            )}
        </>
    );
};

export default LiveTVChannels;
